import React, { Component } from 'react';
import LowRiskButton from '../../../../shared/button/risk-level/LowRiskButton';
import HighRiskButton from '../../../../shared/button/risk-level/HighRiskButton';
import MediumRiskButton from '../../../../shared/button/risk-level/MediumRiskButton';
import './OverallRisk.scss';

class OverallRisk extends Component {
    low = 'LOW';
    medium = 'MEDIUM';
    high = 'HIGH';

    neutralLine = (<div className={'line neutral'} />);
    lowLine = (<div className={'line low'} />);
    mediumLine = (<div className={'line medium'} />);
    highLine = (<div className={'line high'} />);

    render() {
        if (this.props.riskLevel === this.low) {
            // 8 + 13
            return (
                <div className={'overall-risk'}>
                    <div className={'overall-risk-level'}>
                        <LowRiskButton active={true} />
                    </div>
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.lowLine}
                    {this.lowLine}
                    {this.lowLine}
                    {this.lowLine}
                    {this.lowLine}
                    {this.lowLine}
                    {this.lowLine}
                    {this.lowLine}
                </div>
            );
        }

        if (this.props.riskLevel === this.medium) {
            // 16 + 5
            return (
                <div className={'overall-risk'}>
                    <div className={'overall-risk-level'}>
                        <MediumRiskButton active={true} />
                    </div>
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.neutralLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                    {this.mediumLine}
                </div>
            );
        }

        if (this.props.riskLevel === this.high) {
            // 21
            return (
                <div className={'overall-risk'}>
                    <div className={'overall-risk-level'}>
                        <HighRiskButton active={true} />
                    </div>
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                    {this.highLine}
                </div>
            );
        }
    }
}

export default OverallRisk;
